import type {
  ErrorType,
  FilterStatusMapBookingPanel,
  ItineraryBookingPanel,
  ItineraryByIdBookingPanel,
  ItineraryStateBookingPanel,
} from '@web-platform/shared-universal-types/src/redux/state/shared/flightBookingPanel/entities/flights/itinerariesBookingPanel';

export const get = (state: ItineraryStateBookingPanel, id: string): ItineraryBookingPanel =>
  state.byId[id];
export const all = (state: ItineraryStateBookingPanel): ItineraryByIdBookingPanel => state.byId;
export const getFilterStatusMap = (
  state: ItineraryStateBookingPanel,
  id: string,
): FilterStatusMapBookingPanel[] => get(state, id)?.upgrades?.filterStatusMap || [];
export const getItineraryError = (
  state: ItineraryStateBookingPanel,
  id: string,
): ErrorType | undefined => get(state, id)?.error;
